import React from "react";
import { env } from "../../env";

export default function IconText({ icon, title, className = "" }) {
  return (
    <div
      className={`d-flex justify-content-center align-items-center ${className} px-2`}
    >
      {/* <img
        style={{ width: 60, height: 60, zIndex: 1 }}
        alt="service icons"
        src={`${env.iconBaseUrl}${icon}`}
      /> */}

      <div
        className="bg-light-green rounded-pill"
        style={{
          // marginLeft: "-50px",
          display: "table",
          height: "4rem",
          overflow: "hidden",
          background: "#f7f7f7"
        }}
      >
        <div style={{ display: "table-cell", verticalAlign: "middle" }}>
          <div className="icon-svc-sm2">
            <i className={`icon-illustrative ${icon}`} aria-hidden="true"></i>
          </div>
        </div>

        <div style={{ display: "table-cell", verticalAlign: "middle" }}>
          <div
            className="text-start sub-header-label"
            style={{
              marginLeft: "25px",
              // paddingRight: "2rem",
              paddingRight: 35,
              color: "#484848"
            }}
          >
            {title}
          </div>
        </div>
      </div>
    </div>
  );
}
